import React, { useEffect, useState } from 'react';

interface Props {
  url?: string | null;
  initials: string;
  size: number;
  isLive: boolean;
  fontSize?: number;
}

export default function LiveAvatar({ url, initials, size, isLive, fontSize }: Props) {
  const [imgError, setImgError] = useState(false);
  const fs = fontSize ?? Math.round(size * 0.38);
  const displayUrl = url && /^https?:\/\//i.test(url)
    ? `/api/gift-image?url=${encodeURIComponent(url)}`
    : url;

  useEffect(() => {
    setImgError(false);
  }, [url]);

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <div style={{
        width: size, height: size, borderRadius: '50%',
        boxSizing: 'border-box',
        border: isLive ? '3px solid #dc2626' : '3px solid transparent',
        boxShadow: isLive ? '0 0 0 2px rgba(220,38,38,0.18)' : undefined,
        background: '#ede9fe',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: fs, fontWeight: 700, color: '#7c3aed',
        overflow: 'hidden',
        animation: isLive ? 'liveRing 1.8s ease-in-out infinite' : undefined,
      }}>
        {displayUrl && !imgError ? (
          <img src={displayUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setImgError(true)} />
        ) : initials}
      </div>
      {isLive && (
        <div style={{
          position: 'absolute', bottom: -7, left: '50%', transform: 'translateX(-50%)',
          background: '#dc2626', color: '#fff',
          fontSize: Math.max(7, Math.round(size * 0.17)), fontWeight: 800, letterSpacing: 0.4,
          borderRadius: 4, padding: '1px 5px',
          whiteSpace: 'nowrap', border: '1.5px solid #fff',
          lineHeight: 1.5, zIndex: 1,
        }}>EN LIVE</div>
      )}
      <style>{`@keyframes liveRing{0%,100%{box-shadow:0 0 0 2px rgba(220,38,38,0.18)}50%{box-shadow:0 0 0 4px rgba(220,38,38,0.32)}}`}</style>
    </div>
  );
}
